import { render, staticRenderFns } from "./RejectIssue.vue?vue&type=template&id=567e412f&"
import script from "./RejectIssue.vue?vue&type=script&lang=js&"
export * from "./RejectIssue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports